"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OverflowMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _coreHelpers = require("@vfuk/core-helpers");
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/OverflowMenu.style"));
var _scrollElementIntoView = _interopRequireDefault(require("./helpers/scrollElementIntoView"));
var _KeyboardInterceptor = _interopRequireDefault(require("./helpers/KeyboardInterceptor"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var OverflowMenu = /*#__PURE__*/function (_PureComponent) {
  _inherits(OverflowMenu, _PureComponent);
  var _super = _createSuper(OverflowMenu);
  function OverflowMenu() {
    var _this;
    _classCallCheck(this, OverflowMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.componentName = 'OverflowMenu';
    _this.state = {
      focusedElementId: _this.props.activeItem
    };
    _this.elementsListRef = /*#__PURE__*/_react["default"].createRef();
    _this.keyboardInterceptor = new _KeyboardInterceptor["default"]();
    _this.search = '';
    _this.removeClickOutsideHandler = void 0;
    _this.focusNext = function (event) {
      event.preventDefault();
      var childrenIds = _this.filteredChildren.map(function (item) {
        return item.props.value;
      });
      var currentIndex = childrenIds.indexOf(_this.state.focusedElementId || '');
      var nextIndex = currentIndex + 1;
      if (nextIndex < childrenIds.length) {
        _this.setFocus(childrenIds[nextIndex]);
      }
    };
    _this.focusPrevious = function (event) {
      event.preventDefault();
      var childrenIds = _this.filteredChildren.map(function (item) {
        return item.props.value;
      });
      var currentIndex = childrenIds.indexOf(_this.state.focusedElementId || '');
      var previousIndex = currentIndex - 1;
      if (previousIndex >= 0) {
        _this.setFocus(childrenIds[previousIndex]);
      }
    };
    _this.focusFirst = function (event) {
      event.preventDefault();
      _this.setFocus(_this.filteredChildren[0].props.value);
    };
    _this.focusLast = function (event) {
      var _last;
      event.preventDefault();
      _this.setFocus(((_last = (0, _last2["default"])(_this.filteredChildren)) === null || _last === void 0 ? void 0 : _last.props.value) || null);
    };
    _this.selectFocusedElement = function (event) {
      var focusedElement = _this.filteredChildren.find(function (item) {
        return item.props.value === _this.state.focusedElementId;
      });
      if (!(focusedElement !== null && focusedElement !== void 0 && focusedElement.props.disabled)) {
        _this.props.onChange(focusedElement.props.value);
        _this.handleClose();
      }
    };
    _this.handleClose = function () {
      var _this$props = _this.props,
        onClose = _this$props.onClose,
        triggerRef = _this$props.triggerRef;
      onClose();
      if (triggerRef !== null && triggerRef !== void 0 && triggerRef.current) {
        triggerRef.current.focus();
      }
    };
    _this.handleOutsideClick = function (event) {
      if (_this.props.isOpen && _this.props.triggerRef && _this.props.triggerRef.current !== event.target && !_this.props.triggerRef.current.contains(event.target)) {
        _this.props.onOutsideClick();
      }
    };
    _this.handleSearch = function (searchCharacter) {
      var indexOfFocused = _this.state.focusedElementId ? (0, _findIndex["default"])(_this.filteredChildren, function (item) {
        return item.props.value === _this.state.focusedElementId;
      }) : 0;
      var temp = _toConsumableArray(_this.filteredChildren);
      var front = temp.splice(indexOfFocused + 1);
      var childrenReordered = [].concat(_toConsumableArray(front), _toConsumableArray(temp));
      var itemToFocus = childrenReordered.find(function (item) {
        return item.props.text.toLowerCase().startsWith(searchCharacter.toLowerCase());
      });
      if (itemToFocus) {
        _this.setFocus(itemToFocus.props.value);
      }
    };
    _this.setFocus = function (focusId) {
      _this.setState({
        focusedElementId: focusId
      });
      (0, _scrollElementIntoView["default"])(_this.elementsListRef, focusId);
    };
    return _this;
  }
  _createClass(OverflowMenu, [{
    key: "setupKeyboardInterceptor",
    value: function setupKeyboardInterceptor() {
      var _this2 = this;
      var handlers = {
        ArrowDown: this.focusNext,
        ArrowUp: this.focusPrevious,
        Enter: this.selectFocusedElement,
        Space: this.selectFocusedElement,
        Escape: this.handleClose,
        Home: this.focusFirst,
        End: this.focusLast,
        Tab: this.handleClose
      };
      var throttledCb = (0, _throttle["default"])(this.handleSearch, OverflowMenu.debounceTime);
      var clean = (0, _debounce["default"])(function () {
        _this2.search = '';
      }, 1000);
      var fallbackHandler = function fallbackHandler(event) {
        if (event.key.length === 1 && event.key.match(/[a-z]/i)) {
          event.preventDefault();
          _this2.search += event.key;
          throttledCb(_this2.search);
          clean();
        }
      };
      this.keyboardInterceptor.setup(this.elementsListRef.current, handlers, fallbackHandler);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.removeClickOutsideHandler = (0, _coreHelpers.onClickOutside)(this.elementsListRef, this.handleOutsideClick);
      if (this.props.isOpen) {
        this.elementsListRef.current.focus();
        if (this.state.focusedElementId) {
          this.setFocus(this.state.focusedElementId);
        }
      }
      this.setupKeyboardInterceptor();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        this.elementsListRef.current.focus();
        if (this.props.activeItem && this.props.activeItem !== this.state.focusedElementId) {
          this.setFocus(this.props.activeItem);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.keyboardInterceptor.destroy();
      this.removeClickOutsideHandler();
    }
  }, {
    key: "filteredChildren",
    get: function get() {
      var filteredChildren = [];
      _react["default"].Children.forEach(this.props.children, function (child) {
        var component = child === null || child === void 0 ? void 0 : child.type;
        var displayName = component === null || component === void 0 ? void 0 : component.displayName;
        if (displayName && displayName.includes('OverflowMenuItem')) filteredChildren.push(child);
      });
      return filteredChildren;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react["default"].createElement(Styled.OverflowMenu, _extends({
        role: "listbox",
        tabIndex: -1,
        isOpen: this.props.isOpen,
        ref: this.elementsListRef,
        "aria-activedescendant": this.props.isOpen ? this.state.focusedElementId : undefined,
        "aria-label": this.props.srText,
        id: this.props.id,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix),
        "data-component-name": this.componentName
      }, this.props.dataAttributes), this.props.isOpen && this.filteredChildren.map(function (child, index) {
        var _child$props = child.props,
          value = _child$props.value,
          disabled = _child$props.disabled;
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          key: value,
          active: _this3.props.activeItem === value,
          focused: _this3.state.focusedElementId === value,
          onClick: function onClick() {
            if (!disabled) {
              _this3.props.onChange(value);
              _this3.handleClose();
            }
          },
          dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(_this3.props.dataSelectorPrefix, "child-".concat(index))
        });
      }));
    }
  }]);
  return OverflowMenu;
}(_react.PureComponent);
exports.OverflowMenu = OverflowMenu;
OverflowMenu.debounceTime = 500;
OverflowMenu.displayName = "OverflowMenu";
var _default = OverflowMenu;
exports["default"] = _default;
//# sourceMappingURL=OverflowMenu.js.map